<template>
  <div>
    <div class="swiper-outer-container gradient" ref="swiperOuter">
      <div class="swiper" ref="swiper">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <div class="swiper-slide slide1">
            <img src="@/assets/images/signal-slide1.png" alt="" />
          </div>
          <div class="swiper-slide slide2">
            <img src="@/assets/images/signal-slide2.png" alt="" />
          </div>
          <div class="swiper-slide slide3">
            <img src="@/assets/images/signal-slide3.png" alt="" />
          </div>
        </div>
        <!-- If we need pagination -->
        <!-- <div class="swiper-pagination"></div> -->

        <!-- If we need scrollbar -->
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>
    </div>
    <!-- If we need navigation buttons -->
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>
import Swiper, { Pagination, Autoplay, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default {
  name: 'SignalSlider',

  data() {
    return {
	
		};
  },

  mounted() {
		let test = this.$refs.swiperOuter;
    new Swiper(this.$refs.swiper, {
      // configure Swiper to use modules
      modules: [Pagination, Autoplay, Navigation],
      // Optional parameters
      // loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      breakpoints: {
        800: {
          slidesPerView: 2.5,
          spaceBetween: 60,
        },
      },
      on: {
				reachBeginning: function() {
					test.classList.add('gradient');
				},
        reachEnd: function() {
					test.classList.remove('gradient');
        },
      },
    });
  },

  methods: {},

};
</script>

<style lang="scss" scoped>
.swiper-outer-container {
  width: 90%;
  margin: 0 auto;
  position: relative;
  &.gradient {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      width: 80px;
      background: rgb(58, 65, 80);
      background: linear-gradient(90deg, rgba(58, 65, 80, 0) 0%, rgba(58, 65, 80, 1) 100%);
      z-index: 1;
      @media (max-width: $mobile) {
        background: none;
      }
    }
  }
}
.swiper {
  width: 100%;
  height: 240px;
  margin-left: 0;
  margin-right: 0;
  /* padding: 0 80px; */
}
.swiper-slide {
  display: flex;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  img {
    width: 100%;
    height: 100%;
  }
  &.slide1 {
  }
  &.slide2 {
  }
  &.slide3 {
  }
}

.swiper-button-prev {
  &::after {
    content: '';
  }
  width: 50px;
  height: 50px;
  background-image: url('@/assets/icons/swiper-prev.svg');
}
.swiper-button-next {
  &::after {
    content: '';
  }
  width: 50px;
  height: 50px;
  background-image: url('@/assets/icons/swiper-next.svg');
}
</style>
